// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3M23_","notes":"Notes_notes__3Q-68","note":"Notes_note__37k5N","markdown":"Notes_markdown__WusKf"};